import PropTypes from "prop-types";
import dayjs from "dayjs";
import { useIntl } from "react-intl";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { parseUtc } from "../../../../helpers/ScheduleSummary";
import {
  formatLicenseDay,
  licenseState,
  toLicenseDay,
} from "../../../../helpers/EnterpriseLicenseHelper";

const STATE_SEVERITIES = {
  current: "success",
  upcoming: "info",
  ended: "secondary",
};

// Every licence of the organisation, newest first as the API sends them.
// Read-only: a licence is never edited or deleted, a new one is added.
const LicenseHistory = ({ licenses }) => {
  const intl = useIntl();
  const message = (id) => intl.formatMessage({ id });

  return (
    <div data-testid="license-history">
      <DataTable
        value={licenses || []}
        dataKey="id"
        size="small"
        stripedRows
        emptyMessage={message("license_history_empty")}
      >
        <Column
          header={message("license_history_start_date")}
          body={(row) => formatLicenseDay(toLicenseDay(row.startDate))}
        />
        <Column
          header={message("license_history_end_date")}
          body={(row) => formatLicenseDay(toLicenseDay(row.endDate))}
        />
        <Column
          header={message("license_history_added_by")}
          body={(row) => row.addedBy || "-"}
        />
        <Column
          header={message("license_history_added_on")}
          body={(row) =>
            row.createdAt
              ? dayjs(parseUtc(row.createdAt)).format("DD MMM YYYY hh:mm a")
              : "-"
          }
        />
        <Column
          header={message("license_history_state")}
          body={(row) => {
            const state = licenseState(row);
            return (
              <span data-testid="license-state" data-state={state}>
                <Tag
                  severity={STATE_SEVERITIES[state]}
                  value={message(`license_state_${state}`)}
                />
              </span>
            );
          }}
        />
      </DataTable>
    </div>
  );
};

LicenseHistory.propTypes = {
  licenses: PropTypes.array,
};

export default LicenseHistory;
